"use client" // Error components must be Client Components

import { useErrorCapture } from "@/lib/hooks/useErrorCapture"

/**
 * This is the error page for the SubscribeModal.
 *
 * It's pretty generic, with the only thing changing being the text of the error message.
 */
export default function SubscribeModalError({
  error,
  reset,
  component,
}: {
  error: Error & { digest?: string }
  reset: () => void
  component: string
}) {
  useErrorCapture(error, component)

  return (
    <div>
      <h2>Something went wrong!</h2>
      <button
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
      >
        Try again
      </button>
    </div>
  )
}
